export default {
  Radio: {
    parts: ['container', 'control', 'label'],
    baseStyle: {
      control: {
        borderColor: 'primary.base',
        _checked: {
          background: 'primary.base',
          borderColor: 'primary.base',
          _hover: {
            background: 'primary.base',
            borderColor: 'primary.base',
          },
        },
      },
    },
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
